import { useCallback, useState } from "react";
import { IDataMensagens } from "../../../types/api/geral/mensagens";
import truncarString from "../../../helpers/truncarString";
import DialogCriacaoEditMensagem from "./DialogCriacaoEditMensagem";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Mensagens() {

    const [openModal, setOpenModal] = useState<TOpenModalMensagens>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IDataMensagens | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<IDataMensagens>
                titulo="Mensagens"
                endpoints={{
                    listar: "pesquisar-mensagens",
                    deletar: "excluir-mensagem",
                }}
                colunas={colunas}
                queryKey="pesquisar-mensagens"
                onEditar={(mensagem) => {
                    handleModalAction("open", mensagem.id, mensagem)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Mensagem deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar mensagem!"
                mensagemSemDados="Nenhuma mensagem encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditMensagem
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalMensagens = {
    open: number | boolean | null;
    defaultValue: IDataMensagens | null;
} | null

const colunas: ConfiguracaoColunas<IDataMensagens>[] = [
    {
        campo: "programa",
        titulo: "Programa",
    },
    {
        campo: "canal",
        titulo: "Canal",
    },
    {
        campo: "mensagem",
        titulo: "Mensagem",
        render: (value: string) => (
            <span>{truncarString(value, 50)}</span>
        ),
    }
];